import { addClass, getAttributeOrDefault, removeClass } from '../util/dom';
import { isLap } from '../util/breakpoint';

const NAV_SELECTOR = '.js-sub-nav';
const SCROLL_CONTAINER_SELECTOR = '.js-sub-nav-wrapper';
const SECTION_LIST_SELECTOR = '[id^="section--"]';
const LINK_ITEMS_SELECTOR = '.c-sub-nav__link';
const LINK_ITEMS_ACTIVE_CLASS = 'active';
const HIDDEN_CLASS = 'hidden';
const SCROLL_CLASS = 'sticky';
const FIXED_NAV_CLASS = 'fixed-nav';
const HIDE_ELEMENT = '.js-hide-in-sticky';
const SCROLL_ACTIVE_STATE = '.js-scrollable-tab-active-state';
const PLACEHOLDER = '.c-sub-nav-placeholder';
const SCROLL_CONTAINER_HEADER_SELECTOR = '.c-sub-nav__header';
const PRICE_SECTION = 'section--prices';

export function createNewScrollExposeNavListener(): void {
    const nav = document.querySelector<HTMLElement>(NAV_SELECTOR);
    const scrollContainer = document.querySelector<HTMLElement>(SCROLL_CONTAINER_SELECTOR);
    const scrollContainerHeader = document.querySelector<HTMLElement>(SCROLL_CONTAINER_HEADER_SELECTOR);
    const hideElement = document.querySelectorAll<HTMLElement>(HIDE_ELEMENT);
    const sectionList = document.querySelectorAll<HTMLElement>(SECTION_LIST_SELECTOR);
    const linkItems = document.querySelectorAll<HTMLElement>(LINK_ITEMS_SELECTOR);

    const clearLinkItemsActiveClass = (): void => linkItems.forEach(e => removeClass(e, LINK_ITEMS_ACTIVE_CLASS));

    if (nav === null || scrollContainer === null || scrollContainerHeader === null) {
        return;
    }

    sectionList.forEach((element, index) => {
        const link = getSubSectionLink(element);
        const targetOffset = document.querySelector<HTMLElement>('.c-sub-nav-placeholder');
        let offset = 180;
        if (targetOffset) {
            offset = targetOffset.clientHeight;
        }

        new window.Waypoint({
            element,
            offset: offset,
            handler(direction): void {
                if (direction === 'down') {
                    if (link === null || !isInViewport(link, offset)) {
                        return
                    }
                    clearLinkItemsActiveClass();
                    addClass(link, LINK_ITEMS_ACTIVE_CLASS);
                    scrollActiveLinkIntoView(link);
                    setActiveDecoAndScrollIntoView(link);
                    if (element.id === PRICE_SECTION){
                        addClass(scrollContainerHeader, HIDDEN_CLASS);
                        return;
                    }
                    if (scrollContainerHeader.classList.contains(HIDDEN_CLASS)) {
                        removeClass(scrollContainerHeader, HIDDEN_CLASS);
                    }
                } else if (direction === 'up' && (index - 1) >= 0) {
                    const linkItem = linkItems[index - 1];

                    if (!isInViewport(linkItem, offset)) {
                        return
                    }

                    clearLinkItemsActiveClass();
                    addClass(linkItem, LINK_ITEMS_ACTIVE_CLASS);
                    scrollActiveLinkIntoView(linkItem);
                    setActiveDecoAndScrollIntoView(linkItem)
                    if (linkItem.dataset.anchor === '#' + PRICE_SECTION){
                        addClass(scrollContainerHeader, HIDDEN_CLASS);
                        return;
                    }
                    if (scrollContainerHeader.classList.contains(HIDDEN_CLASS)) {
                        removeClass(scrollContainerHeader, HIDDEN_CLASS);
                    }
                }
            },
        })
    });

    initSubNavWaypoint(nav, scrollContainer, hideElement);
}

function scrollActiveLinkIntoView(link: HTMLElement): void {
    if (link.classList.contains('active')) {
        link.scrollIntoView();
    }
}

function initSubNavWaypoint(nav: HTMLElement, scrollContainer: HTMLElement, hideElement: NodeListOf<HTMLElement> | null): void {
    let scrollContainerHeight = 0;
    const placeholderHeight = scrollContainer.offsetHeight;
    const placeholder = document.querySelector<HTMLElement>(PLACEHOLDER);
    //the upper sticky navigation is 56px height in portable view and therefore we take the offsetHeight of the whole
    //container and subtract the upper sticky navigation height to make it smoother
    if (isLap()) {
        scrollContainerHeight = - scrollContainer.offsetHeight + 56;
    }

    if (placeholder === null) {
        return;
    }

    placeholder.style.minHeight = placeholderHeight + 'px';

    new window.Waypoint.Sticky({
        element: scrollContainer,
        stuckClass: 'sticky',
        direction: 'up down',
        offset: scrollContainerHeight,
        handler(direction): void {
            if (direction === 'down') {
                addClass(scrollContainer, SCROLL_CLASS);
                addClass(nav, SCROLL_CLASS);

                if (hideElement) {
                    hideElement.forEach(el => {
                        addClass(el, HIDDEN_CLASS);
                    })
                }

                addClass(document.body, FIXED_NAV_CLASS);
            }

            if (direction === 'up') {
                removeClass(scrollContainer, SCROLL_CLASS);
                removeClass(nav, SCROLL_CLASS);

                if (hideElement) {
                    hideElement.forEach(el => {
                        removeClass(el, HIDDEN_CLASS);
                    })
                }

                removeClass(document.body, FIXED_NAV_CLASS);
            }
        }
    });
}

function getSubSectionLink(section: HTMLElement): HTMLElement | null {
    const id = getAttributeOrDefault(section, 'id', null);
    return document.querySelector(`.c-sub-nav__link[data-anchor="#${id}"]`);
}

function isInViewport (elem: HTMLElement, offset = 0): boolean {
    const bounding = elem.getBoundingClientRect();
    return (bounding.top > 0 && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + offset);
}

function setActiveDecoAndScrollIntoView(currentLink: HTMLElement): void {
    const scrollActiveState = document.querySelector<HTMLElement>(SCROLL_ACTIVE_STATE);
    const leftPosition = currentLink.offsetLeft;
    const subNavDefaultOffsetWidth = 117;
    const subNavWidth = currentLink.offsetWidth ? currentLink.offsetWidth : subNavDefaultOffsetWidth;

    if (scrollActiveState === null) {
        return;
    }

    scrollActiveState.style.width = subNavWidth + 'px';
    scrollActiveState.style.left = leftPosition + 'px';

    if (currentLink.offsetLeft > (window.pageXOffset - subNavWidth)) {
        scrollElementIntoView(currentLink, 'end');
    }

    if (currentLink.offsetLeft <= 0) {
        scrollElementIntoView(currentLink, 'start');
    }
}

function scrollElementIntoView(element: Element, position: any): void {
    element.scrollIntoView({ block: position, behavior: "smooth" });
}

export function refreshWaypoints(): void {
    if (window.Waypoint) {
        // @ts-ignore
        window.Waypoint.refreshAll()
    }
}
